module.exports = __webpack_public_path__ + "img/concreto_para_trabes.acf3aece.png";